// Shared filter helpers so the batch-update filters-box and the custom-action
// filters-box produce an identical filter-query shape and cannot drift.

// A "row" is a react-hook-form filter row: { key: { value }, operator: { value }, value }.
export const isCompleteFilterRow = (f) =>
  Boolean(f?.key && f?.operator);

// Map applied filter rows to the flat { key, operator, value } shape the
// /employees pool and bulk endpoints expect. Incomplete rows are dropped.
export const mapFilterRowsToQuery = (rows = []) =>
  rows.filter(isCompleteFilterRow).map((f) => ({
    key: f.key.value,
    operator: f.operator.value,
    value: f.value,
  }));
